// Dashboard greeting quotes for MortgageFlow
export interface GreetingQuote {
  text: string;
  timeOfDay: 'morning' | 'day' | 'evening';
}

const MORNING_QUOTES: string[] = [
  "Good morning, {firstName}! Time to rise and close those deals!",
  "Hey {firstName}, the sun's up and so are your opportunities. Let's make today count!",
  "Morning, {firstName}! Grab your coffee and let's lock in those rates!",
  "Good morning, {firstName}! A new day, a new chance to make dreams happen!",
  "{firstName}, it's morning! Let's kickstart the day with some winning deals!",
  "Rise and grind, {firstName}! The mortgage market is waiting for you!",
  "Good morning, {firstName}! Today's the day to make those clients smile!",
  "Hey {firstName}, morning vibes are here. Ready to dominate the market?",
  "Morning, {firstName}! Let's start strong and close stronger!",
  "Good morning, {firstName}! The early broker gets the best rates!",
  "{firstName}, it's a fresh morning. Time to build those client connections!",
  "Good morning, {firstName}! Let's hit the ground running and seal some deals!",
  "Morning, {firstName}! Your hustle today sets the stage for success!",
  "Hey {firstName}, good morning! Let's turn opportunities into victories!",
  "Good morning, {firstName}! Time to shine and make those mortgages happen!",
  "{firstName}, morning's here! Let's get those clients into their dream homes!",
  "Good morning, {firstName}! Start the day with a plan and end it with a win!",
  "Morning, {firstName}! The market's open, and you're ready to own it!",
  "Hey {firstName}, good morning! Let's make today's deals unforgettable!",
  "Good morning, {firstName}! Your energy sets the tone—let's make it epic!",
  "{firstName}, it's morning! Time to hustle and make things happen!",
  "Good morning, {firstName}! Fresh day, fresh deals—let's do this!",
  "Morning, {firstName}! Let's turn today's goals into tomorrow's wins!",
  "Hey {firstName}, good morning! The mortgage world is yours to conquer!",
  "Good morning, {firstName}! Start strong, finish stronger!",
  "{firstName}, morning's calling! Let's lock in those loans today!",
  "Good morning, {firstName}! Time to rise, grind, and shine!",
  "Morning, {firstName}! Let's make today's deals the talk of the town!",
  "Hey {firstName}, good morning! Your clients are waiting for your magic!",
  "Good morning, {firstName}! A new day to crush it in the mortgage game!",
  "{firstName}, it's morning! Let's build bridges to new client successes!",
  "Good morning, {firstName}! The early bird closes the best deals!",
  "Morning, {firstName}! Time to turn dreams into keys for your clients!",
  "Hey {firstName}, good morning! Let's make today a deal-closing masterpiece!",
  "Good morning, {firstName}! Your hustle today will shape tomorrow's wins!",
  "{firstName}, morning's here! Let's get those rates locked and loaded!",
  "Good morning, {firstName}! Start the day with fire and close with flair!",
  "Morning, {firstName}! The mortgage market's ready—are you?",
  "Hey {firstName}, good morning! Let's make today's deals legendary!",
  "Good morning, {firstName}! Time to kick off the day with unstoppable drive!"
];

const DAY_QUOTES: string[] = [
  "Hey {firstName}, the day's in full swing—keep those deals rolling!",
  "{firstName}, it's go time! Let's keep pushing those mortgages through!",
  "Midday hustle, {firstName}! You're making things happen out there!",
  "Keep it up, {firstName}! The day's yours to dominate the market!",
  "{firstName}, the day's hot! Let's lock in those loans and keep moving!",
  "Hey {firstName}, midday momentum—keep closing those deals!",
  "{firstName}, you're in the zone! Let's make every call count!",
  "Keep rocking it, {firstName}! The day's deals are waiting for you!",
  "{firstName}, midday's your time to shine—keep those clients smiling!",
  "Hey {firstName}, the day's on fire! Let's close some big ones!",
  "{firstName}, keep the momentum going—your clients are counting on you!",
  "Midday grind, {firstName}! Let's turn opportunities into successes!",
  "Hey {firstName}, you're killing it! Keep those deals flowing!",
  "{firstName}, the day's in motion—let's make every moment count!",
  "Keep pushing, {firstName}! The mortgage market's yours to own!",
  "Hey {firstName}, midday hustle—let's get those loans approved!",
  "{firstName}, you're on a roll! Keep making those client dreams real!",
  "Midday, {firstName}! Let's keep the deal train moving full speed!",
  "Hey {firstName}, the day's yours—keep closing with confidence!",
  "{firstName}, keep the energy high! The market's waiting for your moves!",
  "Midday motivation, {firstName}! Let's seal those deals tight!",
  "Hey {firstName}, you're unstoppable today—keep those loans coming!",
  "{firstName}, the day's in your hands—make every deal a win!",
  "Keep it going, {firstName}! Midday's perfect for closing big!",
  "Hey {firstName}, the day's alive—let's make those mortgages happen!",
  "{firstName}, you're crushing it! Keep the deals coming strong!",
  "Midday, {firstName}! Let's turn every call into a closed loan!",
  "Hey {firstName}, keep the hustle alive—today's your day!",
  "{firstName}, the market's buzzing—keep locking in those rates!",
  "Midday grind, {firstName}! Let's make every client a success story!",
  "Hey {firstName}, you're in control—keep those deals on track!",
  "{firstName}, the day's yours—let's close with power and precision!",
  "Keep pushing, {firstName}! Midday's made for your kind of hustle!",
  "Hey {firstName}, the day's hot—let's keep those loans moving!",
  "{firstName}, you're on fire! Keep making those client connections!",
  "Midday, {firstName}! Let's turn opportunities into closed deals!",
  "Hey {firstName}, keep the pace—today's deals are yours to win!",
  "{firstName}, the day's in full gear—keep those mortgages rolling!",
  "Keep it up, {firstName}! Midday's your time to shine bright!",
  "Hey {firstName}, the day's yours—let's make every deal count!"
];

const EVENING_QUOTES: string[] = [
  "Good evening, {firstName}! Time to close out the day with a win!",
  "Hey {firstName}, evening's here—let's finish those deals strong!",
  "{firstName}, great work today! Let's tie up those loose ends!",
  "Evening, {firstName}! One last push to make today legendary!",
  "Hey {firstName}, the day's winding down—let's close with flair!",
  "{firstName}, evening's calling—seal those final deals!",
  "Good evening, {firstName}! Let's wrap up the day with success!",
  "Hey {firstName}, you crushed it today—let's finish strong!",
  "{firstName}, evening's here—time to lock in those last loans!",
  "Evening, {firstName}! Let's make tonight's deals the best yet!",
  "Hey {firstName}, great hustle today—let's close out with a bang!",
  "{firstName}, evening's your time to shine—wrap up those wins!",
  "Good evening, {firstName}! Let's make the last deals count!",
  "Hey {firstName}, the day's almost done—finish it like a champ!",
  "{firstName}, evening vibes—let's close those final mortgages!",
  "Evening, {firstName}! Time to seal the day's successes!",
  "Hey {firstName}, you owned today—let's wrap it up right!",
  "{firstName}, good evening! Let's make those last calls count!",
  "Evening, {firstName}! Finish the day with a deal-closing flourish!",
  "Hey {firstName}, great work—let's end the day on a high note!",
  "{firstName}, evening's here—time to close out with pride!",
  "Good evening, {firstName}! Let's make tonight's deals epic!",
  "Hey {firstName}, the day's been yours—finish it with a win!",
  "{firstName}, evening hustle—let's lock in those final rates!",
  "Evening, {firstName}! Time to wrap up the day's successes!",
  "Hey {firstName}, you've rocked it—let's close out strong!",
  "{firstName}, good evening! Let's make those last deals shine!",
  "Evening, {firstName}! Finish the day with unstoppable energy!",
  "Hey {firstName}, great day—let's end it with a deal-closing bang!",
  "{firstName}, evening's calling—wrap up those wins with style!",
  "Good evening, {firstName}! Let's close the day like a pro!",
  "Hey {firstName}, the night's young—finish those deals strong!",
  "{firstName}, evening hustle—let's make those final calls count!",
  "Evening, {firstName}! Time to seal the day with success!",
  "Hey {firstName}, you've dominated today—let's wrap it up right!",
  "{firstName}, good evening! Let's close out with a winning streak!",
  "Evening, {firstName}! Finish the day with deals that dazzle!",
  "Hey {firstName}, great work today—let's end on a high note!",
  "{firstName}, evening's here—time to close with confidence!",
  "Good evening, {firstName}! Let's make today's final deals unforgettable!"
];

export function getTimeOfDay(): 'morning' | 'day' | 'evening' {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) {
    return 'morning';
  } else if (hour >= 12 && hour < 18) {
    return 'day';
  } else {
    return 'evening';
  }
}

export function getGreetingQuote(firstName?: string, t?: (key: string) => string): GreetingQuote {
  const timeOfDay = getTimeOfDay();
  let quotes: string[];
  
  // If translation function is provided, use translated quotes
  if (t) {
    switch (timeOfDay) {
      case 'morning':
        quotes = t('dashboard.greeting.morning').split('|');
        break;
      case 'day':
        quotes = t('dashboard.greeting.day').split('|');
        break;
      case 'evening':
        quotes = t('dashboard.greeting.evening').split('|');
        break;
    }
  } else {
    // Fallback to English quotes
    switch (timeOfDay) {
      case 'morning':
        quotes = MORNING_QUOTES;
        break;
      case 'day':
        quotes = DAY_QUOTES;
        break;
      case 'evening':
        quotes = EVENING_QUOTES;
        break;
    }
  }
  
  // Use date as seed for consistent quote throughout the day for same user
  const today = new Date();
  const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
  const index = seed % quotes.length;
  
  // Replace {firstName} placeholder with actual name or fallback
  const selectedQuote = quotes[index];
  const finalText = selectedQuote.replace('{firstName}', firstName || 'there');
  
  return {
    text: finalText,
    timeOfDay
  };
}